
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/notice",
      function () {
        return require("private-next-pages/help/notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/notice"])
      });
    }
  